// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"53233e17","453":"de2a23a4","667":"205de5c3","977":"1bcb42bd"}[chunkId] + ".chunk.js";
};